import { CartProducts } from './cart-products';
import { Coupon } from './coupon';
import { Log } from './log';
import { User } from './user';

export interface Cart extends Log {
    id?: any;

    /**
     * @description User id is taken from user who log in.
     */
    user: User;

    /**
     * @description Products added to the cart. Every product in the cart have a valid LuxuraProduct id, quantity and insertedAt.
     */
    products: CartProducts[];

    /**
     * @description : This will show the total amount that user has to  pay for ordered products
     */
    subTotal: number;

    /**
     * indicates if the payment link is generated for cart
     */
    isPaymentLinkGenerated: boolean;

    /**
     * If isPaymentLinkGenerated is true,
     */
    paymentLink?: string;

    actualOrderId?: any;

    couponsToApply: Coupon[];
    total: number;

    hasReducedPrice: boolean;
}
